<template>
  <vdl-basic-provider-card
    ref="providerCard"
    :provider="provider"
    :extendedCard="extendedCard"
    :index="index"
    :booking-quote="bookingQuote"
    :blured="blured"
    :keyword="keyword"
    :beforeSamplePlay="beforeSamplePlay"
    :section="section"
    :lastActiveText="lastActiveText"
    :force-link-default="forceLinkDefault"
    @click:profile="$emit('click:profile', $event)"
  >
    <div>
        <md-button id="book_now_btn" class="md-primary md-theme-blue provider-card-contact-btn" @click.prevent.native="onBook">Book now</md-button>
        <md-button class="md-primary md-theme-blue provider-card-contact-btn" @click.prevent.native="onContact">Contact</md-button>
    </div>
  </vdl-basic-provider-card>
</template>
<script src="./vdlBasicVoiceActorCard.mjs"></script>